import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Segmented } from "../../../../design-system";
import { GenericSelect } from "../../../../common/GenericSelect";
import { useBudget } from "../BudgetContext";
import classes from "./BudgetTabs.module.less";

const BASE = "/superadmin/demo/budget";

type TabKey = "track" | "forecast" | "sources";

// Track · Budget · Source (Source last). "forecast" route is labelled "Budget".
const TABS: Array<{ key: TabKey; label: string }> = [
    { key: "track", label: "Track" },
    { key: "forecast", label: "Budget" },
    { key: "sources", label: "Source" },
];

/** Fiscal-year selector + Track / Budget / Source segment selector. Track is the
 * default view. Rendered at the top of each view. */
export const BudgetTabs: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { workspace, year, setYear } = useBudget();

    const active: TabKey =
        TABS.find((t) => location.pathname.startsWith(`${BASE}/${t.key}`))?.key ??
        "track";

    // The demo only cares about the current fiscal year.
    const fy = workspace.currentYear;

    return (
        <div className={classes.bar}>
            <GenericSelect
                className={classes.year}
                value={year}
                onChange={setYear}
                options={[{ value: fy, label: `FY${fy}` }]}
            />
            <Segmented
                className={classes.tabs}
                value={active}
                onChange={(v) => navigate(`${BASE}/${v}`)}
                options={TABS.map((t) => ({ value: t.key, label: t.label }))}
            />
        </div>
    );
};
